/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购知识</el-breadcrumb-item>
      <el-breadcrumb-item>导购知识视频</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formProInfo" class="user-search">
			
          <el-form-item label="视频名称" >
            <el-input size="small" v-model="formProInfo.name" placeholder="输入产品名称"></el-input>
          </el-form-item>
		  
		  <el-form-item label="分类1">
		   <el-select size="small" v-model="formProInfo.firstLevelId" placeholder="请选择" @change="changetype">
		       <el-option v-for="(item,index) in typeList1" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="分类2">
		   <el-select size="small" v-model="formProInfo.secondLevelId" placeholder="请选择"  @change="changetype1" clearable>
		      <el-option v-for="(item,index) in typeList2" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="分类3">
		   <el-select size="small" v-model="formProInfo.thirdLevelId" placeholder="请选择" clearable>
		      <el-option v-for="(item,index) in typeList3" :label="item.name" :value="item.id"></el-option>
		    </el-select>
		  </el-form-item>
		  
    	  <el-form-item label="操作人">
    	    <el-input size="small" v-model="formProInfo.updator" placeholder="输入创建人"></el-input>
    	  </el-form-item>
		  
		  <el-form-item label="是否允许下载" class="huan">
		   <el-select size="small" v-model="formProInfo.downloadStatus" placeholder="请选择">
		      <el-option label="是" value="1"></el-option>
		      <el-option label="否" value="0"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="是否允许分享" class="huan">
		   <el-select size="small" v-model="formProInfo.shareStatus" placeholder="请选择">
		      <el-option label="是" value="1"></el-option>
		      <el-option label="否" value="0"></el-option>
		    </el-select>
		  </el-form-item>
		  
		  <el-form-item label="状态">
		   <el-select size="small" v-model="formProInfo.active" placeholder="请选择">
		      <el-option label="启用" value="1"></el-option>
		      <el-option label="禁用" value="0"></el-option>
		    </el-select>
		  </el-form-item>
		  
         <!-- <el-form-item label="创建时间">
    	    <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd">
                </el-date-picker>
    	  </el-form-item>
          <el-form-item> -->
			<el-button size="small" type="info" icon="el-icon-refresh-left" @click="refrea" class="refrea">重置</el-button>
            <el-button size="small" type="primary" icon="el-icon-search" @click="search" class="search">搜索</el-button>
           
          </el-form-item>
        </el-form>
		 <el-button size="small" type="primary" icon="el-icon-plus" @click="add" class="add">新增</el-button>
        <!--列表-->
        <el-table size="small" @selection-change="selectChange" :data="proInfoList" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
		  <el-table-column align="center" prop="sortNumber" label="排序" >
		  </el-table-column>
          <el-table-column align="center" sortable prop="name" label="产品名称" >
          </el-table-column>
          <el-table-column align="center" sortable prop="firstLevelName" label="分类1">
          </el-table-column>
		  <el-table-column align="center" sortable prop="secondLevelName" label="分类2">
		  </el-table-column>
		  <el-table-column align="center" sortable prop="thirdLevelName" label="分类3">
		  </el-table-column>
    	  <el-table-column align="center" sortable prop="downloadStatus" label="是否允许下载" >
    	  </el-table-column>
		  <el-table-column align="center" sortable prop="shareStatus" label="是否允许分享" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="active" label="状态" >
		  </el-table-column>
		  <el-table-column align="center" sortable prop="updator" label="最后操作人" >
		  </el-table-column>
          <!-- <el-table-column align="center" sortable prop="createTime" label="案例类型" min-width="140">
          </el-table-column> -->
		  <el-table-column align="center" sortable prop="updateTime" label="创建时间" >
		  </el-table-column>
         <!-- <el-table-column align="center" sortable prop="editTime" label="修改时间" min-width="120">
            <template slot-scope="scope">
              <div>{{scope.row.editTime|timestampToTime}}</div>
            </template>
          </el-table-column> -->
          <!-- <el-table-column align="center" sortable prop="status" label="状态" min-width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status=='1'?nshow:fshow" active-color="#13ce66" inactive-color="#ff4949" @change="editType(scope.$index, scope.row)">
              </el-switch>
            </template>
          </el-table-column> -->
          <el-table-column  align="center"  label="操作" min-width="140">
            <template slot-scope="scope">

              <!-- <el-button size="mini" type="success" @click="getDatas(scope.$index, scope.row.id)">查看</el-button> -->
              <el-button size="mini"  type="primary" @click="handleEdit(scope.row)">编辑</el-button>
			  <el-button size="mini" type="danger" @click="deleteProInfo(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="70%" @click='closeDialog("edit")'>
          <el-form label-width="120px" ref="editForm" :model="editForm" >
            <el-form-item label="产品名称" prop="productName">
              <el-input size="small" v-model="editForm.productName" auto-complete="off" placeholder="请输入产品名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="产品介绍类型" :prop="editForm.introductionType">
              <el-radio v-model="editForm.introductionType" label="0">产品介绍</el-radio>
              <el-radio v-model="editForm.introductionType" label="1">产品卖点</el-radio>
              <el-radio v-model="editForm.introductionType" label="2">安装视频</el-radio>
            </el-form-item> -->
            <el-form-item label="产品类型" :prop="editForm.productType">
              <el-radio v-model="editForm.productType" label="0">家用</el-radio>
              <el-radio v-model="editForm.productType" label="1">商用</el-radio>
            </el-form-item>
            <el-form-item label="内容类型" :prop="editForm.contentType">
              <el-radio v-model="editForm.contentType" label="0">链接</el-radio>
              <el-radio v-model="editForm.contentType" label="1">图文</el-radio>
              <el-radio v-model="editForm.contentType" label="2">文件</el-radio>
            </el-form-item>
            <el-form-item  label="链接信息" v-if="editForm.contentType == 0">
              <el-input size="small" v-model="editForm.linkUrl" auto-complete="off" placeholder="请输入网址"></el-input>
              <div class="el-upload__tip">请输入以“http://”或者“https://” 开头的网址链接</div>
            </el-form-item>
            <el-form-item  label="文件信息"  v-if="editForm.contentType == 2">
              <!-- accept=".png,.jpeg,.gif,.pdf,.jpg,.JPG" -->
              <el-upload
                class="upload-files"
                v-model="diaFrom.list"
                :limit="3"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :before-upload="beforeAvatarUpload"
                :on-remove="handleRemove"
                :on-success="onUploadSuccess"
                :file-list="resultFilelist"
                list-type="picture"
                :action="uploadUrl()"
                :http-request="customUpload"
                accept=".pdf,.doc,.docx,.ppt,pptx">
                <el-button size="small" type="primary">点击上传文件</el-button>
                <div slot="tip" class="el-upload__tip">上传文件，仅支持PDF文件、WORD文档、PPT文件，最多可上传3份文件</div>
                
              </el-upload>
            </el-form-item>
            <el-form-item   label="图文信息"  v-if="editForm.contentType == 1">
              
              <el-upload
                class="upload-demo"
                :action="uploadUrl()"
                :http-request="customUpload"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :file-list="resultFilelist1"
                :limit='3'
                accept=".png,.jpg,.jpeg"
                list-type="picture">
                <el-button size="small" type="primary">点击上传图片</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg、jpeg、png 图片，最多可上传3张图片</div>
              </el-upload>
              <el-input style="margin-top:10px"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="描述"
                v-model="editForm.description">
              </el-input>
            </el-form-item>
            


            
          </el-form>


          <el-dialog :visible.sync="imgVisible" :append-to-body="true" style="" :title="imgTitle">
            <div style="justify-content:center;align-item:center;text-align:center;display:flex" >
              <el-image
                style="width:100%;min-height:400px"
                :src="imgUrl"
              fit="contain"></el-image>
            </div>
          </el-dialog>


          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click='closeDialog("edit")'>取消</el-button>
            <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">保存</el-button>
          </div>
        </el-dialog>
      </div>
    </template>

    <script>
    // 导入请求方法
    import { uploadFile } from '../../api/axiosFun';
    import {
      deleteProInfo,
      modifyProInfo,
      createProInfo,
      getProInfo,
	  deleteShoppyFileById,
      queryPageShoppyFileList,
	  getShoppyTypeList
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
		  keys:1,
		  typeList1:'',
		  typeList2:'',
		  typeList3:'',
          dateValue:[],
          textarea2:'',
          loading: false, //是显示加载
          title: '',
          editFormVisible: false, //控制编辑页面显示与隐藏
          dataAccessshow: false, //控制数据权限显示与隐藏
          unitAccessshow: false, //控制所属单位隐藏与显示
          // 编辑与添加
          editForm: {
            id:'',
            productName: '',
            productType: '0',
            introductionType: '2',
            contentType: '0',
            description:'',
            content:[],
            linkUrl:'',
            attachments:[],
          },

          // 选择数据
          selectdata: [],
          

          // 请求数据参数
          formProInfo: {
            pageIndex: 1,
            pageSize: 10,
            // 产品名称(支持右模糊查询)
            name: '',
            //创建人(支持右模糊查询)
            updator: '',
            //所属导购：1-导购知识视频；2-服务视频；3-导购文件
            category:1,
            //分类状态：0-禁用；1-启用
            active:'',
			firstLevelId:'',
			secondLevelId:'',
			thirdLevelId:'',
			downloadStatus:'',
			shareStatus:'',
			
          },
    	  
          //产品介绍列表
          proInfoList: [],
         
          
          // 分页参数
          pageparm: {
            currentPage: 1,
            pageSize: 10,
            total:0,
          },
          diaFrom:{
            desc:'',
            list:[]
          },
          resultFilelist:[],
          resultFilelist1:[],
          fileList: [],
          imgVisible:false,
          imgTitle:'',
          imgUrl:''
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.getData(this.formProInfo)
		this.changedao()

      },
      mounted(){
        // document.addEventListener("paste", this.handlePaste);
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		  //添加
		  add: function() {
		  	this.$router.push({ path: '/productadd2?shuo=' + '新增' })
		   
		  },
		  //编辑
		  handleEdit: function(row) {
		  	console.log(99999,row)
		  	this.$router.push({ path: '/productadd2?id='+row.id + '&shuo=' + '编辑' })
		   
		  },
		  changetype(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
					 level:2,
					 category:1,
					 firstLevelId:this.formProInfo.firstLevelId,
					 secondLevelId:''
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.secondLevelId = null
				this.formProInfo.thirdLevelId = null
				this.typeList2 = res.data
				
				}
			  })
		  },
		  changetype1(e){
			  console.log(123456,e)
			  //this.formProInfo.firstLevelId = e
			  let parm = {
				 level:3,
				 category:1,
				 firstLevelId:this.formProInfo.firstLevelId,
				 secondLevelId:this.formProInfo.secondLevelId
						 
			  }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.formProInfo.thirdLevelId = null
				this.typeList3 = res.data
				
				}
			  })
		  },
		  changedao(){
			 let parm = {
				 level:1,
				 category:1,
				 firstLevelId:'',
				 secondLevelId:''
				 
			 }
			  getShoppyTypeList(parm).then(res => {
				console.log(123)
				this.loading = false
				if (res.success == false) {
				  this.$message({
					type: 'info',
					message: res.msg
				  })
				} else {
				this.typeList1 = res.data
				
				}
			  })
		  },
		refrea(){
			this.formProInfo.name=''
			this.formProInfo.updator=''
			this.formProInfo.active=''
			this.formProInfo.firstLevelId=''
			this.formProInfo.secondLevelId=''
			this.formProInfo.thirdLevelId=''
			this.formProInfo.downloadStatus=''
			this.formProInfo.shareStatus=''
		},
        contentTypeFormatter(row,column){
          let contentTypeName = row.contentType == 0 ?'链接' :row.contentType == 1 ?'图文':'文件' 
          return contentTypeName
          
        },
        editFormInit(){
          this.editForm = {
            id:'',
            productName: '',
            productType: '0',
            introductionType: '2',
            contentType: '0',
            description:'',
            content:[],
            linkUrl:'',
            attachments:[],
          }
          this.resultFilelist1 = []
          this.resultFilelist = []
        },
        // async handlePaste(event){
        //   const clipboardData = event.clipboardData || window.clipboardData;
        //   if(clipboardData){
        //     const items = clipboardData.items;
        //     if(items && items.length >0){
        //       for(let i=0;i<items.length; i++){
        //         const item = items[i];
        //         if(item.kind === 'file' && item.type.startsWith('image/')){
        //           const file = item.getAsFile();
        //           const formData= new FormData();
        //           formData.append('file', file);
        //           if(file){
        //              evaluateUpload(formData,{
        //               token: this.$util.cookies.token,
        //               userId:this.info ? this.info.userId :''
        //             }).then((response)=>{
        //               const { data, code }=response.data || {};
        //               // 11 上传成功，应该返回
        //               if(code ==='APPLY SUCCESS'){
        //                 if(data){
        //                   this.resultFilelist.push({
        //                     url: data.url,
        //                     name: data.name,
        //                     uid: file.uid
        //                   });
        //                 console.log(this.resultFilelist,'剪贴成功数据');
        //               }else if(response && response.msg){
        //                  console.log('upload failed',response.msg); 
        //                 }
        //              }
        //             }).catch((error)=>{console.log(error)
        //             });
        //           }
        //         }
        //       }
        //     }
        //   }
        // },

        //限制上传个数不超过9个
        handleExceed(files,fileList){
          if(fileList && fileList.length == 3){
            this.$message.warning('上传文件不可超过3个')
          }
        },
        handlePreview(file){
          console.log(file)
          if(this.editForm.contentType == 2){
            window.open(file.fileTemporaryUrl)
            // const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
            // this.resultFilelist.splice(index,1);
          }else if(this.editForm.contentType == 1){
            this.imgUrl = file.fileTemporaryUrl
            this.imgVisible = true
            this.imgTitle = file.name
          }
        },
        beforeAvatarUpload(file){
          console.log(file)
        },
        customUpload(req){
          let _this = this
          console.log(req)
           // 创建一个新的FormData对象
          const formData = new FormData();
          // 将文件添加到formData中
          formData.append('file', req.file);
          
            uploadFile(this.uploadUrl(), formData).then(response => {
              console.log(response.data.success)
              if(response.data.success){
                let data = response.data.data
                console.log(data)
                // _this.editForm.attachments.push(data)
                if(_this.editForm.contentType ==2){
                  _this.resultFilelist.push({
                      url:require('../../assets/img/pdf.png'),
                      fileTemporaryUrl:data.fileTemporaryUrl,
                      fileId:data.fileId,
                      name: data.ossFile.fileName,
                      uid: req.file.uid,
                      attachments:data
                  })
                  this.dealPDF();
                  setTimeout(()=>{
                    this.dealPDF();
                  },1);
                }else if(_this.editForm.contentType == 1){
                  _this.resultFilelist1.push({
                      url:data.fileTemporaryUrl,
                      fileTemporaryUrl:data.fileTemporaryUrl,
                      fileId:data.fileId,
                      name: data.ossFile.fileName,
                      uid: req.file.uid,
                      mediaObjInfo:data
                  })
                  
                }
                
              }else{
                console.log('???')
                this.$message.error('文件上传失败，请稍后再试！')
              }
             
                
              console.log(_this.resultFilelist)
              // 处理响应
            }).catch(error => {
              // 处理错误
              console.log(error)
              //  this.$message.error('文件上传失败，请稍后再试！')
            });
        },
        handleRemove(file,fileList){
          console.log(file)
          if(!file){
            return
          }

          if(this.editForm.contentType ==2){
            const index = this.resultFilelist.findIndex(item => item.fileId === file.fileId)
            this.resultFilelist.splice(index,1);
          }else if(this.editForm.contentType == 1){
            const index1 = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
            this.resultFilelist1.splice(index1,1);
          }
          
        },
        // 设置请求头里面的token 称 userId
        // reqHeaders(){
        //   return {
        //     'Content-Type':'multipart/form-data',
        //     satoken:getCookie('satoken'),
        //   };
        // },  
        onUploadSuccess(response,file,fileList){
          console.log('onUploadSuccess',response)
          // if(response && response.code ==='APPLY_SUCCESS'){
          //     if(response.data){
          //       this.resultFilelist.push({
          //           url:response.data.url,
          //           name: response.data.name,
          //           uid: file.uid
          //       })
          //       // this.dealPDF();
          //       // setTimeout(()=>{
          //       //   this.dealPDF();
          //       // },1);
          //     }
          //   }else if (response && response.msg){ 
          //     console.log('upload failed', response.msg);
          //   }
        },
        uploadUrl(){
          return '/mtl/marking/api/main/oss-file/upload-file'
        },
        dealPDF(){
            var liElements = document.querySelectorAll('ul.el-upload-list,el-upload-list--picture li.el-upload-list__item');
            liElements.forEach(function(liElement){
              var aElement = liElement.querySelector('a.el-upload-list__item-name');
              if(aElement && (aElement.textContent.includes('.pdf') || aElement.textContent.includes('.doc') || aElement.textContent.includes('.docx') || aElement.textContent.includes('.ppt') || aElement.textContent.includes('.pptx'))){
                var imgElement = liElement.querySelector('img.el-upload-list__item-thumbnail')
                if(imgElement){
                  imgElement.src= require('../../assets/img/pdf.png');// 普换为你想要的新图片的URL
                }
              }
            })
        },

		  // 获取数据方法
		  getDatas(index, row) {
		    this.loading = true

		    let pageparm= {
		      pageIndex: 1,
		      pageSize: 10,
		     name: '',
		     parentMenuCode:''
		    }
		    console.log(777,row)
		    if(row != undefined && row != 'undefined'){
		  	  pageparm.parentMenuCode = row
		    }

		    ModuleNodes(pageparm).then(res => {
		      this.loading = false
		      if (res.success == false) {
		        this.$message({
		          type: 'info',
		          message: res.msg
		        })
		      } else {
		        this.proInfoList = res.data
				this.proInfoList.map((item,index) =>{
					  if(item.shareStatus==1){
						  item.shareStatus = '是'
					  }else{
						  item.shareStatus = '否'
					  }
					  if(item.active==1){
							item.active = '启动'
					  }else{
							item.active = '禁用'
					  }
					  if(item.downloadStatus==1){
					  		 item.downloadStatus = '是'
					  }else{
					  		item.downloadStatus = '否'
					  }
				})

		        // 分页赋值
		        this.pageparm.pageIndex = this.formProInfo.pageIndex
		        this.pageparm.pageSize = this.formProInfo.pageSize
		        this.pageparm.total = res.data.total
		      }
		    })
		  },
        // 获取数据方法
        getData(pageparm) {
          this.loading = true
          console.log(pageparm)
          if(this.dateValue.length > 0){
            pageparm.createStartTime = this.dateValue[0]
            pageparm.createEndTime = this.dateValue[1]
          }

          queryPageShoppyFileList(pageparm).then(res => {
            console.log(123)
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.proInfoList = res.data
			  this.proInfoList.map((item,index) =>{
			  	  if(item.shareStatus==1){
			  		  item.shareStatus = '是'
			  	  }else{
			  		  item.shareStatus = '否'
			  	  }
			  	  if(item.active==1){
			  			item.active = '启动'
			  	  }else{
			  			item.active = '禁用'
			  	  }
			  	  if(item.downloadStatus==1){
			  	  		 item.downloadStatus = '是'
			  	  }else{
			  	  		item.downloadStatus = '否'
			  	  }
			  })
              // 分页赋值
              this.pageparm.currentPage = this.formProInfo.pageIndex
              this.pageparm.pageSize = this.formProInfo.pageSize
              this.pageparm.total = res.total
            }
          })
        },
        // 分页插件事件
        callFather(parm) {
          this.formProInfo.pageIndex = parm.currentPage
          this.formProInfo.pageSize = parm.pageSize
          this.getData(this.formProInfo)
        },
        //搜索事件
        search() {
          console.log(123)
          console.log(this.dateValue)
          this.formProInfo.pageIndex = 1
          this.getData(this.formProInfo)
        },


        // 修改type
        editType: function(index, row) {
          this.loading = true
          let parm = {
            menuCode: '',
            status: ''
          }
          parm.menuCode = row.menuCode
          let lock = row.status
		  console.log(55,lock)
          if (lock == 0) {
            parm.status = 1
          } else {
            parm.status = 0
          }
          // 修改状态
          Modulestate(parm).then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.$message({
                type: 'success',
                message: '状态修改成功'
              })
			        this.formProInfo.parentMenuCode = row.parentCode
              this.getData(this.formProInfo)
            }
          })
        },
        
        // 编辑、添加提交方法
        saveProInfo(){
            console.log(this.content)
             if(!this.editForm.productName){
              return this.$message({
                      type: 'warning',
                      message: '请填写产品名称'
                    })
            }
            
          let parm = {
            productName: this.editForm.productName,
            productType:parseInt(this.editForm.productType),
            introductionType : parseInt(this.editForm.introductionType),
            contentType : parseInt(this.editForm.contentType)
          }
          if(parm.contentType == 0){
             let linkReg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+).)+([A-Za-z0-9-~\/])+$/
            const isLink = linkReg.test(this.editForm.linkUrl)
            // console.log(this.editForm.linkUrl)
            // console.log(isLink)
            if(!isLink){
              return this.$message({
                      type: 'warning',
                      message: '请填写正确的链接地址'
                    })
            }
            parm = {
              ...parm,
              linkUrl:this.editForm.linkUrl
            }
            // parm.append('linkUrl', this.editForm.url);
          }else if(parm.contentType == 1){
            if(this.resultFilelist1.length < 1){
              return this.$message({
                      type: 'warning',
                      message: '请上传图片'
                    })
            }
            let content = []
            this.resultFilelist1.map((item,index)=>{
              content.push({
                remarks:'',
                mediaObjInfo:item.mediaObjInfo
              })
            })
            parm = {
              ...parm,
              content:content,
              description:this.editForm.description
            }
          }else if(parm.contentType == 2){
            if(this.resultFilelist.length < 1){
              return this.$message({
                      type: 'warning',
                      message: '请上传文件'
                    })
            }
            let attachments = []
            this.resultFilelist.map((item,index)=>{
              attachments.push(item.attachments)
            })
            parm = {
              ...parm,
              attachments:attachments
            }
          }
          if(this.editForm.id){
            parm = {
              ...parm,
              id:this.editForm.id
            }
          }
          console.log(parm)
    		  if(this.title=='产品介绍详情'){
          modifyProInfo(parm)
    				.then(res => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  if (res.success) {
              this.getData(this.formProInfo)
              this.editFormInit()
    					this.$message({
    					  type: 'success',
    					  message: '保存成功！'
    					})
    				  } else {
    					this.$message({
    					  type: 'info',
    					  message: res.msg
    					})
    				  }
    				})
    				.catch(err => {
    				  this.editFormVisible = false
    				  this.loading = false
    				  this.$message.error('保存失败，请稍后再试！')
    				})
    			}else{

					
          createProInfo(parm)
    					.then(res => {
                this.loading = false
                this.editFormVisible = false
    					  if (res.success) {
                this.getData(this.formProInfo)
                this.editFormInit()
    						this.$message({
    						  type: 'success',
    						  message: '保存成功！'
    						})
    					  } else {
    						this.$message({
    						  type: 'info',
    						  message: res.msg
    						})
    					  }
    					})
    					.catch(err => {
    					  this.editFormVisible = false
    					  this.loading = false
    					  this.$message.error('保存失败，请稍后再试！')
    					})
    			}
            // } else {
            //   return false
            // }
          // })
        },

        handleClick(data, checked, node) {
          if (checked) {
            this.$refs.tree.setCheckedNodes([])
            this.$refs.tree.setCheckedNodes([data])
            this.unitparm.deptId = data.id
            this.unitparm.deptName = data.name
            //交叉点击节点
          } else {
          }
        },

        // 选择复选框事件
        selectChange(val) {
          this.selectdata = val
        },
        // 关闭编辑、增加弹出框
        closeDialog(dialog) {
          if (dialog == 'edit') {
            this.editFormVisible = false
          } else if (dialog == 'perm') {
            this.dataAccessshow = false
          } else if (dialog == 'unit') {
            this.unitAccessshow = false
          }
        },
        // 删除用户
        deleteProInfo(index, row) {
          this.$confirm('确定要删除吗?', '信息', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              // 删除
              deleteShoppyFileById(row.id)
                .then(res => {
                  if (res.success) {
                    this.$message({
                      type: 'success',
                      message: '数据已删除!'
                    })
                    this.getData(this.formProInfo)
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('数据删除失败，请稍后再试！')
                })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除！'
              })
            })
        }

      }
    }
    </script>

    <style scoped>
    .user-search {
      margin-top: 20px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .el-form-item{
  	  width: 220px;
  }
  .el-input{
  	  width: 150px;
  }
  /deep/ .el-input--small{
  	  width: 150px;
  }
  /deep/ .el-form--inline .el-form-item__label{
	  width: 70px;
	  overflow-wrap: break-word;
	  
  }
  /deep/ .huan .el-form-item__label{
  	  line-height: 20px;
  	  
  }
  .search{
	  position: absolute;
	  right: 0;
	  top: 68px;
  }
  .add{
	  margin-bottom: 30px;
  }
  .refrea{
	  position: absolute;
	  right: 0;
	  top: 5px;
  }
  .user-search{
	  position: relative;
  }
    </style>





// WEBPACK FOOTER //
// src/views/knowledge/product2.vue